import { useCallback, useEffect, useState } from "react";

import { useApi } from "../../../context/ApiContext";
import { useAuth } from "../../../context/AuthContext";
import { useData } from "../../../context/DataContext";

export const useDashboardAnalytics = () => {
  const { isAuthenticated } = useAuth();
  const { globalProjectId } = useData();
  const api = useApi();

  const [analytics, setAnalytics] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAnalytics = useCallback(async () => {
    if (!isAuthenticated) return;
    setIsLoading(true);
    try {
      const params = {};
      if (globalProjectId && globalProjectId !== "ALL") {
        params.projectId = globalProjectId;
      }
      const [taskStatsRes, projectCostRes, costByTypeRes, progressByTypeRes, employeeTaskStatsRes, recentActivitiesRes] =
        await Promise.all([
          api.get(`/dashboard/task-stats`, { params }),
          api.get(`/dashboard/project-cost`, { params }),
          api.get(`/dashboard/cost-by-type`, { params }),
          api.get(`/dashboard/progress-by-type`, { params }),
          api.get(`/dashboard/employee-task-stats`, { params }),
          api.get(`/dashboard/recent-activities`, { params })
        ]);

      const mergedAnalytics = {
        ...taskStatsRes.data,
        ...projectCostRes.data,
        costByType: costByTypeRes.data,
        progressByType: progressByTypeRes.data,
        employeeTaskStats: employeeTaskStatsRes.data,
        recentActivities: recentActivitiesRes.data
      };

      setAnalytics(mergedAnalytics);
    } catch (err) {
      console.error("Failed to fetch analytics:", err);
    } finally {
      setIsLoading(false);
    }
  }, [isAuthenticated, api, globalProjectId]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchAnalytics();
    }
  }, [isAuthenticated, fetchAnalytics]);

  return {
    analytics,
    isLoading,
    refreshAnalytics: fetchAnalytics
  };
};
